// == Import npm
import React from "react";
import { Link, Route, Switch } from "react-router-dom";
import { Button, Image, Typography } from "antd";

// == Import Icons
import { MdHome } from "react-icons/md";

// Image
import Logo from "@tokens/Assets/web/img/logo/01_standard.png";

// == Import Component
import SearchByResident from "../SearchByResident/SearchByResident";
import SearchByVisitor from "../SearchByVisitor/SearchByVisitor";
import MeetingPage from "../MeetingPage/MeetingPage";
import VisitDayPage from "../VisitDayPage/VisitDay";
import VisitPlannedPage from "../VisitPlannedPage/VisitPlanned";
import SearchByLostBadge from "../SearchByLostBadge/SearchByLostBadge";
import Loader from "components/SearchBar/Loader/Loader";
import Extract from "components/Extract/Extract";
import ListKeyCards from "components/ListKeyCards/ListKeyCards";
import HistoryVisitors from "components/HistoryVisitors/HistoryVisitors";

// == import i18n
import { useTranslation } from "react-i18next";

// == Import CSS
import "./homePage.less";

import MenuHeader from "./MenuHeader";
import { useSelector } from "react-redux";

import MainPage from "../MainPage";
import WhoAreYou from "components/WhoAreYou/WhoAreYou";

const HomePage = () => {
  const [t] = useTranslation();
  const { isFetching, useKeyCard } = useSelector(state => state.visits);

  return (
    <div style={{ position: "relative", zIndex: "999", height: "100%" }}>
      <Switch>
        <Route path="/" exact>
          <div
            className="homePage__header"
            style={{
              display: "flex",
              flexGrow: "1",
              justifyContent: "space-between",
            }}
          >
            {isFetching && <Loader />}

            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "0 25px",
              }}
            >
              <Image src={Logo} width="200px" preview={false} className="logo" />
              <Typography.Title level={2} style={{ margin: "0" }}>
                {t("HospitalityManagement")}
              </Typography.Title>
              <MenuHeader />
            </div>
          </div>
          <MainPage />
        </Route>

        <Route path="/searchByResident" exact>
          <Link to="/" style={{ color: "white" }}>
            <Button
              style={{ position: "absolute", top: "20px", left: "50px" }}
              type="primary"
              size="large"
              icon={<MdHome style={{ verticalAlign: "-5px", marginRight: "8px" }} />}
            >
              {t("BackToHome")}
            </Button>
          </Link>
          <SearchByResident />
        </Route>
        <Route path="/whoareyou" exact>
          <Link to="/" style={{ color: "white" }}>
            <Button
              style={{ position: "absolute", top: "20px", left: "50px" }}
              type="primary"
              size="large"
              icon={<MdHome style={{ verticalAlign: "-5px", marginRight: "8px" }} />}
            >
              {t("BackToHome")}
            </Button>
          </Link>
          <WhoAreYou />
        </Route>

        <Route path="/searchByVisitor" exact>
          <Link to="/" style={{ color: "white" }}>
            <Button
              style={{ position: "absolute", top: "20px", left: "50px" }}
              type="primary"
              size="large"
              icon={<MdHome style={{ verticalAlign: "-5px", marginRight: "8px" }} />}
            >
              {t("BackToHome")}
            </Button>
          </Link>
          <SearchByVisitor />
        </Route>

        <Route path="/meetingPage/:id" exact>
          <Link to="/" style={{ color: "white" }}>
            <Button
              style={{ position: "absolute", top: "20px", left: "50px" }}
              type="primary"
              size="large"
              icon={<MdHome style={{ verticalAlign: "-5px", marginRight: "8px" }} />}
            >
              {t("BackToHome")}
            </Button>
          </Link>
          <MeetingPage useKeyCard={useKeyCard} />
        </Route>

        <Route path="/visitPlanned" exact>
          <Link to="/" style={{ color: "white" }}>
            <Button
              style={{ position: "absolute", top: "20px", left: "50px" }}
              type="primary"
              size="large"
              icon={<MdHome style={{ verticalAlign: "-5px", marginRight: "8px" }} />}
            >
              {t("BackToHome")}
            </Button>
          </Link>
          <VisitPlannedPage />
        </Route>

        <Route path="/visitDay" exact>
          <Link to="/" style={{ color: "white" }}>
            <Button
              style={{ position: "absolute", top: "20px", left: "50px" }}
              type="primary"
              size="large"
              icon={<MdHome style={{ verticalAlign: "-5px", marginRight: "8px" }} />}
            >
              {t("BackToHome")}
            </Button>
          </Link>
          <VisitDayPage />
        </Route>

        <Route path="/extract" exact>
          <Link to="/" style={{ color: "white" }}>
            <Button
              style={{ position: "absolute", top: "20px", left: "50px", zIndex: "2147500999" }}
              type="primary"
              size="large"
              icon={<MdHome style={{ verticalAlign: "-5px", marginRight: "8px" }} />}
            >
              {t("BackToHome")}
            </Button>
          </Link>
          <Extract />
        </Route>

        <Route path="/searchByLostBadge" exact>
          <Link to="/" style={{ color: "white" }}>
            <Button
              style={{ position: "absolute", top: "20px", left: "50px" }}
              type="primary"
              size="large"
              icon={<MdHome style={{ verticalAlign: "-5px", marginRight: "8px" }} />}
            >
              {t("BackToHome")}
            </Button>
          </Link>
          <SearchByLostBadge />
        </Route>
        <Route path="/list-keycard" exact>
          <Link to="/" style={{ color: "white" }}>
            <Button
              style={{ position: "absolute", top: "20px", left: "50px" }}
              type="primary"
              size="large"
              icon={<MdHome style={{ verticalAlign: "-5px", marginRight: "8px" }} />}
            >
              {t("BackToHome")}
            </Button>
          </Link>
          <ListKeyCards />
        </Route>

        <Route path="/history-visitor" exact>
          <Link to="/" style={{ color: "white" }}>
            <Button
              style={{ position: "absolute", top: "20px", left: "50px" }}
              type="primary"
              size="large"
              icon={<MdHome style={{ verticalAlign: "-5px", marginRight: "8px" }} />}
            >
              {t("BackToHome")}
            </Button>
          </Link>
          <HistoryVisitors />
        </Route>
      </Switch>
    </div>
  );
};

export default HomePage;
